import { patchCompany } from "../../cs_edit";

export function initCustomerNameInlineEdit() {
  $(".customers-table .company-name")
    .off("click.cs-inline-edit-name")
    .on("click.cs-inline-edit-name", function (e) {
      e.stopPropagation();
      if ($(this).find(".inline-edit-input").length) return;

      const currentName = $(this).attr("data-full-name") || "";
      const id = $(this).closest(".customer-row").attr("data-id");
      if (!id) return;

      const originalHTML = $(this).html();

      const input = document.createElement("input");
      input.type = "text";
      input.value = currentName;
      input.className = "inline-edit-input";
      input.required = true

      $(this).text("");
      $(this).addClass("is-editing");
      $(this).append(input);
      input.focus();
      input.select();

      let saved = false;

      const save = () => {
        if (saved) return;
        saved = true;

        const newName = input.value.trim();
        if (newName === currentName) {
          cancel();
          return;
        }

        $(this).removeClass("is-editing");
        $(this).text("Saving...");
        $(this).addClass("inline-edit-saving");

        patchCompany(id, { name: newName }, $(this)[0], originalHTML);
      };

      const cancel = () => {
        saved = true;
        input.remove();
        $(this).text(currentName);
        $(this).removeClass("is-editing");
        $(this).html(originalHTML);
      };

      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          const newName = input.value.trim();
          if (newName === "") {
            input.reportValidity();
            return;
          }
          save();
        } else if (event.key === "Escape") {
          event.preventDefault();
          cancel();
        }
      });

      input.onblur = cancel;
    });
}
